import React from "react";
import {
  HomeIcon,
  MenuIcon,
  OpenLinkIcon,
  OpenProjectIcon,
  PlusIcon,
} from "../Icons";
import { env } from "../../../environments";
import { postToServer } from "../../../store/utils/postToServer";
import styles from "./TopBar.module.scss";
type Props = {
  email: string;
  environment: string;
  selectedProjectName?: string;
  selectedProjectId?: string;
  setCreateProjectModalVisible?: () => void;
  isRendering?: boolean;
  setSelectedProjectId: (i: string) => void;
  setSelectedCompositions?: (id: number | null) => void;
  setRenderedCompositions?: (
    id: number | null,
    success?: boolean
  ) => number[] | undefined;
};
export const TopBar = ({
  email,
  setSelectedProjectId,
  environment,
  setCreateProjectModalVisible,
  selectedProjectName,
  isRendering,
  selectedProjectId,
  setSelectedCompositions,
  setRenderedCompositions,
}: Props) => {
  // const DOCUMENTATION_URL = 'https://canary-protocol-ef2.notion.site/Blings-io-Documentation-e943e5dc87034d9583cd73d8ca86aff8';
  const DOCUMENTATION_URL = 'https://help.blings.io/creator';
  return (
    <div className={styles.TopRow}>
      <div className={styles.Left}>
        {!selectedProjectName ? (
          <div className={styles.Title}>Welcome!</div>
        ) : (
          <div
            className={styles.SelectedProjectTitle}
            onClick={() => {
              postToServer("openUrl", {
                url: `${env[environment].studio}${selectedProjectId ?? ""}`,
              });
            }}
          >
            {selectedProjectName}
          </div>
        )}
        <div className={styles.userName}>{email}</div>
      </div>
      <div className={styles.Right}>
        {selectedProjectName ? (
          <div
            {...(!isRendering && {
              onClick: () => {
                setSelectedProjectId("");
                setSelectedCompositions && setSelectedCompositions(null); //reset selected and rendered compositions
                setRenderedCompositions && setRenderedCompositions(null);
              },
            })}
            className={isRendering ? styles.Disabled : ""}
          >
            <HomeIcon />
          </div>
        ) : (
          <>
            <div
              className={styles.Action}
              onClick={() => {
                postToServer("openUrl", {
                  url: `${env[environment].studio}${
                    selectedProjectId ?? ""
                  }`,
                });
              }}
            >
              <OpenLinkIcon />
            </div>
            <div
              style={{ marginTop: "2px" }}
              className={styles.Action}
              onClick={setCreateProjectModalVisible}
            >
              <PlusIcon />
            </div>
            <div
              className={styles.Menu}
              onClick={() => {
                postToServer("openUrl", {
                  url: DOCUMENTATION_URL,
                });
              }}
            >
              <MenuIcon />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
